import React from 'react'

const TopLoadingBar = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 9999,
        pointerEvents: 'none',
        overflow: 'hidden',
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
      }}
    >
      <style>{`@keyframes topbar-indeterminate {
        0% { left: -40%; width: 40%; }
        50% { left: 30%; width: 50%; }
        100% { left: 100%; width: 40%; }
      }`}</style>
      <div
        style={{
          position: 'absolute',
          top: 0,
          height: '100%',
          borderRadius: '9999px',
          background: 'linear-gradient(90deg, rgba(99,102,241,0.4) 0%, rgba(99,102,241,1) 50%, rgba(99,102,241,0.4) 100%)',
          animation: 'topbar-indeterminate 1.1s ease-in-out infinite',
        }}
      />
    </div>
  )
}

export default TopLoadingBar
